import initializingSmartScript from './initializingSmartScript.js';

export default function setAppsListLink(data) {

    if (!data) {
        return null;
    }

     const linksMap = {
        ios: data.mobile_app_link_ios,
        android: data.mobile_app_link_android,
        app_gallery: data.mobile_app_link_app_gallery,
        galaxy_store: data.mobile_app_link_galaxy_store,
        get_apps: data.mobile_app_link_get_apps
    };

    Object.entries(linksMap).forEach(([key, rawLink]) => {
        const buttons = document.querySelectorAll(`.js-button-${key}`);
        const link = rawLink.trim();

        if (!buttons.length) {
            return null;
        }

        if (typeof rawLink === 'string' && link !== '') {

            buttons.forEach(button => {
                button.setAttribute('href', link);
                button.classList.remove('_hidden');
            });

        } else {

            // Добавляем _hidden, если ссылка пустая
            buttons.forEach(button => {
                button.classList.add('_hidden');
                button.removeAttribute('href');
            });
        }
    });
}



// WEBPACK FOOTER //
// ./_layout/js/setAppsListLink.js